const cardItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20drama%20and%20conflict%20theme%20with%20neon%20green%20accents%20on%20black%20background%2C%20entertainment%20gossip%20aesthetic%2C%20minimal%20square%20composition%2C%20editorial%20style&width=500&height=500&seq=card-01-drama&orientation=landscape',
    tag: '独家内幕',
    title: '某知名制片人爆料：选角背后的权色交易',
    time: '2小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20whistleblower%20and%20secret%20theme%20on%20dark%20background%20with%20acid%20green%20glow%2C%20investigative%20journalism%20aesthetic%2C%20minimal%20square%20composition&width=500&height=500&seq=card-02-expose&orientation=landscape',
    tag: '黑料曝光',
    title: '女团成员私下不和证据被前工作人员放出',
    time: '4小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20contract%20and%20dispute%20theme%20on%20dark%20background%20with%20neon%20green%20highlights%2C%20legal%20drama%20aesthetic%2C%20minimal%20square%20composition&width=500&height=500&seq=card-03-contract&orientation=landscape',
    tag: '合约纠纷',
    title: '顶流艺人解约案细节流出：违约金高达九位数',
    time: '6小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20award%20ceremony%20controversy%20theme%20on%20dark%20background%20with%20neon%20green%20accents%2C%20dramatic%20spotlight%20aesthetic%2C%20minimal%20square%20composition&width=500&height=500&seq=card-04-award&orientation=landscape',
    tag: '颁奖争议',
    title: '年度颁奖礼结果遭质疑，评委收钱传闻四起',
    time: '8小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20secret%20romance%20theme%20on%20dark%20background%20with%20neon%20green%20highlights%2C%20paparazzi%20and%20gossip%20aesthetic%2C%20minimal%20square%20composition&width=500&height=500&seq=card-05-romance&orientation=landscape',
    tag: '恋情实锤',
    title: '两位一线明星被拍同游海外，恋情浮出水面',
    time: '10小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20live%20streaming%20drama%20theme%20on%20dark%20background%20with%20acid%20green%20glow%2C%20social%20media%20broadcast%20aesthetic%2C%20minimal%20square%20composition&width=500&height=500&seq=card-06-live&orientation=landscape',
    tag: '直播翻车',
    title: '头部主播带货翻车现场：产品当场出问题',
    time: '12小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Premium%20magazine%20editorial%20layout%20on%20dark%20background%20with%20neon%20green%20accents%2C%20luxury%20gossip%20magazine%20cover%20aesthetic%2C%20dramatic%20and%20bold%20composition%2C%20spotlight%20style&width=1000&height=450&seq=card-07-editorial&orientation=landscape',
    tag: '编辑推荐',
    title: '年度盘点：2026上半年娱乐圈十大未解之谜',
    desc: '从明星恋情到资本博弈，从综艺争议到网红翻车——这些轰动一时的事件至今真相成谜。51爆料网编辑部为你梳理那些仍未揭开的娱乐圈谜团。',
    time: '今日更新',
    featured: true,
  },
];

export default function Cards() {
  const normalCards = cardItems.filter((c) => !c.featured);
  const featuredCard = cardItems.find((c) => c.featured);

  return (
    <section id="cards" className="relative py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/10 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap mb-4">
            <i className="ri-article-line text-[10px]"></i>
            图文资讯
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 tracking-tight">
            更多 <span className="font-heading italic text-accent-400">劲爆内容</span>
          </h2>
          <p className="text-foreground-400 text-sm mt-3 max-w-lg mx-auto">
            持续更新最新爆料图文，八卦不停、吃瓜不止
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {normalCards.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group block rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 cursor-pointer hover:border-accent-500/20 transition-all"
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex px-2.5 py-1 bg-accent-500 text-background-950 text-[10px] font-bold rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-100 group-hover:text-accent-400 transition-colors line-clamp-2 leading-snug mb-2">
                  {item.title}
                </h3>
                <span className="text-[11px] text-foreground-600">{item.time}</span>
              </div>
            </a>
          ))}
        </div>

        {featuredCard && (
          <a
            href="#cards"
            className="group block mt-4 md:mt-5 rounded-2xl overflow-hidden bg-background-100 border border-accent-500/10 hover:border-accent-500/20 transition-all cursor-pointer"
          >
            <div className="flex flex-col md:flex-row">
              <div className="md:w-[45%] relative aspect-[16/9] md:aspect-auto overflow-hidden">
                <img
                  src={featuredCard.image}
                  alt={featuredCard.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="inline-flex px-3 py-1.5 bg-accent-500 text-background-950 text-xs font-bold rounded-full whitespace-nowrap">
                    {featuredCard.tag}
                  </span>
                </div>
              </div>
              <div className="md:w-[55%] p-6 md:p-8 flex flex-col justify-center">
                <h3 className="text-xl md:text-2xl font-bold text-foreground-50 group-hover:text-accent-400 transition-colors mb-3 leading-snug">
                  {featuredCard.title}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed mb-3">
                  {featuredCard.desc}
                </p>
                <span className="text-xs text-foreground-600">{featuredCard.time}</span>
              </div>
            </div>
          </a>
        )}
      </div>
    </section>
  );
}